












import DiyPage from '../page/index.vue'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  {
    components: {
      DiyPage,
    },
  },
  () => class {},
)
